<template>
  <footer class="footer" itemprop="description">
    <div class="footer__wrapper anim__wrapper">
      <div class="svg-container" :data-anim="isMobile() ? false : ''">
        <img src="/static/vector/logo.svg" alt="Bersi Serlini" class="footer__svg">
        <img src="/static/vector/festival-franciacorta.svg" alt="Festival Franciacorta" class="footer__svg">
      </div>
      <div class="marquee">
        <div
          class="marquee-cont marquee3k"
          data-speed="0.75"
          data-pausable="true"
          :data-anim="isMobile() ? false : ''"
          :js-ref="hideMobile"
        >
        </div>
        <div class="u-visuallyhidden">
          <p data-lang="it" ref="it">
            Sabato 15 e Domenica 16 Settembre 2018 dalle 10 alle 2
            <a
              href="https://goo.gl/maps/bEUcaufrqT52"
              rel="noopener"
              target="_blank"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >- Cantine Bersi Serlini: Via Cereto, 7 25050 Provaglio di Iseo (Bs)</a>
            <a
              href="tel:+390309823338"
              rel="noopener"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >- Tel: +39 030 9823338</a>
            <a
              href="mailto:festival@bersiserlini.it"
              rel="noopener"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >
              - Mail: festival@bersiserlini.it</a>
          </p>

          <p data-lang="en" ref="en">
            Saturday 15 and Sunday 16 September 2018 from 10am to 2am - Cantine Bersi Serlini:
            <a
              href="https://goo.gl/maps/bEUcaufrqT52"
              rel="noopener"
              target="_blank"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >Via Cereto, 7 - 25050 Provaglio di Iseo (Bs)</a>
            <a
              href="tel:+390309823338"
              rel="noopener"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >- Tel: +39 030 9823338</a>
            <a
              href="mailto:visite@bersiserlini.it"
              rel="noopener"
              data-mouse=""
              data-mouse-attractionstate="disactive"
              data-hover-type="zoom"
            >Mail: festival@bersiserlini.it</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import FontFaceObserver from 'fontfaceobserver';
import Marquee3k from '@/assets/lib/marquee3k';

import { qs, isMobile } from '@/scripts/utils';

export default {
  name: 'Footer',

  props: ['hideMobile'],

  data() {
    return {
      windowW: innerWidth,
      isMobile,
    };
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },

  watch: {
    lang(newVal) {
      if (newVal) {
        qs('.marquee3k').classList.remove('is-init');
        qs('.marquee3k__wrapper', this.$el).remove();

        this.init();
      }
    },
  },

  mounted() {
    if (!isMobile()) this.$el.style.opacity = 0;

    const font = new FontFaceObserver('Apercu', {
      weight: 400,
    });

    font.load(null, 5000).then(() => {
      this.init();
    });

    this.$eventHub.$on('windowResized', () => {
      if (this.windowW < 768 && window.innerWidth > 767 && this.$store.state.route.name === 'event') {
        this.$el.style.opacity = 1;
      }
    });
  },

  methods: {
    init() {
      const p = document.createElement('p');
      p.classList.add('marquee_text');
      p.innerHTML = this.$refs[this.lang].innerHTML;
      qs('.marquee3k').appendChild(p);

      Marquee3k.init();
      Marquee3k.refreshAll();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 120px;
  padding: 35px 10px 20px;

  background: $color-light;
  -webkit-mask: linear-gradient(to bottom,rgba(0,0,0,.1) 0,rgba(0,0,0,1) 20px,#000 100px);

  z-index: z-index(footer);

  -webkit-touch-callout: none;
  -webkit-user-select: none;
   -khtml-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;

  &.bg-hide {
    background: none;
    -webkit-mask: none;

    pointer-events: none;
  }

  @include mq(xxs) {
    padding: 35px 30px 20px;
  }

  @include mq(sm) {
    background: none;
    -webkit-mask: none;
  }

  @include mq($from: xs, $and: $is-820) {
    padding: 0px 30px 45px;
  }

  @media (max-width: 1440px) and (max-height: 900px) and (min-width: 941px) {
    padding: 35px 30px 20px;
  }

  &__wrapper {
    position: relative;
    max-width: $container-width;
    margin: 0 auto;

    overflow: hidden;

    @extend %flex;
    justify-content: space-between;
    align-items: center;
  }

  .svg-container {
    position: relative;
    width: 75px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
  }

  .footer__svg {
    display: inline-block;
    position: relative;
    width: 22px;
    opacity: 0.9;

    margin: 0;

    &:nth-child(odd) {
      width: 40px;
    }
  }
}

</style>

<style lang="scss">
@import '../application';

.marquee {
  display: inline-block;
  position: relative;
  -webkit-text-size-adjust: 100%;
  width: calc(100% - 100px);

  overflow: hidden;

  .marquee3k__copy {
    display: inline-block;
    padding-right: 20px;
    text-decoration: none;
    box-sizing: border-box;
  }

  div {
    display: inline-block;
  }
}

#app[js-view="event"] {
  @include mq($until: sm) {
    .footer {
      visibility: hidden !important;
      pointer-events: none !important;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue